import { IonPage } from '@ionic/react';
import { FeedFilterLookup, FeedFilterParamType } from 'model';
import { FormSelectBox } from '../components/Forms/FormSelectBox';
import { TopicSearchBox } from '../components/Forms/TopicSearchBox';
import { Header } from '../components/Header';
import { IconButton } from '../components/IconButton';
import { IconArrowBack, IconCheck } from '../components/QuirkIcons';
import { QuirkIonContent } from '../components/QuirkIonContent';
import { FormValueType } from '../hooks/useFormValues';
// Styles
// eslint-disable-next-line css-modules/no-unused-class
import sharedStyles from '../styles/Shared.module.css';

export const FeedFilters: React.FC<{
	setValues: (value: FormValueType<FeedFilterParamType>) => void;
	feedFilterValues: FeedFilterParamType;
	onDismiss: () => {};
}> = ({ onDismiss, setValues, feedFilterValues }) => {
	return (
		<IonPage>
			<Header
				title="Feed Filter"
				left={<IconButton icon={<IconArrowBack />} onClick={() => onDismiss()} />}
				right={<IconButton label="Apply" icon={<IconCheck />} onClick={() => onDismiss()} />}
			/>
			<QuirkIonContent>
				<div className={sharedStyles.contentWrapper}>
					<TopicSearchBox label="Topic" topic={feedFilterValues.topic} setValues={setValues} />

					<FormSelectBox
						id="filterBy"
						setValues={setValues}
						field={{
							value: feedFilterValues.filterBy as string,
							errors: []
						}}
						label="Filter By"
						options={FeedFilterLookup}
					/>
				</div>
			</QuirkIonContent>
		</IonPage>
	);
};
